import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {sleep} from '@/utils/helpers';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Observable, catchError, tap, throwError} from 'rxjs';
import {environment} from 'environments/environment';
import {GenrateToken} from '../common/Models/generateToken.model';

@Injectable({
    providedIn: 'root'
})
export class AppService {
    public user: any = null;
    public currentEmail: string;
    public currentPassword: string;

    constructor(
        private httpClient: HttpClient,
        private router: Router,
        private toastr: ToastrService
    ) {}
    //Api Variable
    baseUrl = environment.apiUrl;

    generateToken(genrateToken: GenrateToken) {
        return this.httpClient
            .post(`${this.baseUrl}/Auth/GenerateToken`, genrateToken)
            .pipe(
                tap((result) => {
                    localStorage.removeItem('authUser');
                    localStorage.setItem('authUser', JSON.stringify(result));
                })
            );
    }

    login(email: any, password: any) {
        this.currentEmail = email;
        this.currentPassword = password;
        return this.httpClient
            .post(`${this.baseUrl}/User/Login`, {email, password})
            .pipe(
                tap((result: any) => {
                    this.toastr.success('Login success');
                    localStorage.setItem(
                        'authUser',
                        JSON.stringify({token: result.token})
                    );
                })
            );
    }

    superAdminlogin(email: any, password: any) {
        return this.httpClient
            .post(`${this.baseUrl}/User/SuperAdminLogin`, {email, password})
            .pipe(
                tap((result) => {
                    this.toastr.success('Login success');
                })
            );
    }

    registration(userModel: any): Observable<any> {
        return this.httpClient
            .post(`${this.baseUrl}/User/Registration`, userModel)
            .pipe
            //catchError(this.error)
            ();
    }
    tenantRegistration(userModel: any): Observable<any> {
        return this.httpClient
            .post(`${this.baseUrl}/Tanent/TenantRegistration`, userModel)
            .pipe
            //catchError(this.error)
            ();
    }
    logout() {
        localStorage.removeItem('authUser');
        const domain = window.location.hostname;
        const isSubDomain = domain.split('.').length > 2;
        if (isSubDomain) {
            this.router.navigate(['/login']);
        } else {
            this.router.navigate(['/register']);
        }
    }
    isLoggedIn() {
        const auth = JSON.parse(localStorage.getItem('authUser'));
        //this.user = this.getUserDetails();
        return localStorage.getItem('authUser') !== null;
    }

    isAdminUser() {
        const userDetail = JSON.parse(
            localStorage.getItem('UserDetail') || '{}'
        );
        // TODO: This implementation has to change for security reasons
        return userDetail?.role?.roleName?.toLocaleLowerCase() === 'admin';
    }

    isTopManagementUser() {
        const userDetail = JSON.parse(
            localStorage.getItem('UserDetail') || '{}'
        );
        // TODO: This implementation has to change for security reasons
        return (
            userDetail?.role?.roleName === 'Top Management'
        );
    }
    resetPassword(reciversEmail: any) {
        return this.httpClient
            .post(`${this.baseUrl}/User/ResetPassword`, {reciversEmail})
            .pipe(
                tap((result) => {
                    // catchError(this.error);
                })
            );
    }
    updatePassword(email: any, password: any) {
        return this.httpClient
            .post(`${this.baseUrl}/User/UpdatePassword`, {email, password})
            .pipe(
                tap((result) => {
                    //catchError(this.error);
                })
            );
    }
    //Decode Token

    // Get the user details from the token
    getUserDetails(): any {
        const userDetail = JSON.parse(localStorage.getItem('UserDetail'));
        if (!!userDetail) {
            const userEmail = userDetail.Email;
            if (userEmail) {
                return userEmail;
            }
        }
        return null;
    }
}
